import { render, staticRenderFns } from "./CashRegisterSetup.vue?vue&type=template&id=186bb05f&scoped=true&"
import script from "./CashRegisterSetup.vue?vue&type=script&lang=js&"
export * from "./CashRegisterSetup.vue?vue&type=script&lang=js&"
import style0 from "./CashRegisterSetup.vue?vue&type=style&index=0&id=186bb05f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186bb05f",
  null
  
)

export default component.exports